const REWARDLIST = [
    { id: 1, amount: 1000 },
    { id: 2, amount: 5000 },
    { id: 3, amount: 10000 },
    { id: 4, amount: 21000 },
    { id: 5, amount: 51000 },
    { id: 6, amount: 100000 },
    { id: 7, amount: 100000 },
    { id: 8, amount: 500000 },
    { id: 9, amount: 850000 },
    { id: 10, amount: 1000000 },
    { id: 11, amount: 2100000 },
    { id: 12, amount: 5100000 },
    { id: 13, amount: 7210000 },
    { id: 14, amount: 10000000 },
    { id: 15, amount: 20000000 },
    { id: 16, amount: 70000000 },
    { id: 17, amount: 120000000 }
]
export default REWARDLIST;
